import { Button, Flex, ModalV2 } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { EntityModeContent } from "./EntityModeContent";
import { EumMetadataBlock } from "./EumMetadataBlock";
import { FamilyModeContent } from "./FamilyModeContent";
import { tableWrapper } from "./styles_vanilla.css";
import type { ChangeInspectionModalProps } from "./types";

export const ChangeInspectionModal = (props: ChangeInspectionModalProps) => {
  const { isOpen, onClose, onDeleteChange, readOnly = false, subtitle, mode } = props;

  const hasContent =
    mode === "entity"
      ? props.changes && props.changes.length > 0
      : props.familyChange !== undefined;

  if (!isOpen || !hasContent) {
    return null;
  }

  const metadataChange =
    mode === "entity" ? props.changes.find((change) => change.metadata) : undefined;

  return (
    <ModalV2
      show={isOpen}
      onHide={onClose}
      title="Proposed changes"
      description={subtitle ?? undefined}
      size="large"
      data-testid="change-inspection-modal"
    >
      <ModalV2.Body>
        <Flex flexDirection="column" gap={SPACING.MEDIUM}>
          {metadataChange?.metadata && (
            <EumMetadataBlock
              metadata={metadataChange.metadata}
              changeRequestId={metadataChange.changeRequestId}
            />
          )}
          <div className={tableWrapper}>
            {mode === "entity" ? (
              <EntityModeContent
                changes={props.changes}
                readOnly={readOnly}
                onDeleteChange={onDeleteChange}
              />
            ) : (
              <FamilyModeContent
                familyChange={props.familyChange}
                readOnly={readOnly}
                onDeleteChange={onDeleteChange}
              />
            )}
          </div>
        </Flex>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex justifyContent="flex-end">
          <Button variant="neutral" onClick={onClose} data-testid="inspection-modal-close">
            Close
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
